import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

import { IExposureCorporation, IExposureMap } from './map-exposure.types';

export function useMapExposure({
  companyId,
  corporationId,
}: {
  companyId?: number;
  corporationId?: number;
}): {
  data:
    | { exposure: IExposureMap; corporations: IExposureCorporation[] }
    | undefined;
  error: unknown;
  mutate: KeyedMutator<unknown>;
} {
  const query = new URLSearchParams();

  if (companyId) query.append('companyId', companyId.toString());

  if (corporationId) query.append('corporationId', corporationId.toString());

  const {
    data,
    error,
    mutate,
  }: {
    data: { exposure: IExposureMap; corporations: IExposureCorporation[] };
    error: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(`exposure-map/summary?${query}`, SWRFetcher({ method: 'GET' }));

  return {
    data,
    error,
    mutate,
  };
}
